var modules_b3384f04 = {"container":"_1aujf23","table":"_10z860p"};
import "../../../assets/BuMsKk_z.css";

export { modules_b3384f04 as default };
//# sourceMappingURL=TableView.module.less.js.map
